import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Modal, Input, Button, Switch, DatePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import {
  DoubleRightOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { routes } from "../../Routes";
import { getExpiryProducts } from "../../API  Functions/SessionHistoryFunctions";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import i18next from "i18next";
import moment from "moment";
import ProductExpiryTable from "./Tables/ProductExpiryTable";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import dayjs from "dayjs";
import FutureDateFilter from "../ui/FutureDateFilter";
import { checkPermission } from "../../Utils/permissionHelper";
import SearchBox from "../CustomWidgets/SearchBox";
import { XCircle, Clock, TrendingDown } from "lucide-react";
import BulkUploadExpiry from "../../modals/UploadBulkExpiry";

const ProductExpiry = () => {
  const { t } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );

  const [loading, setloading] = useState(false);
  const [expiryData, setExpiryData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [query, setquery] = useState("");
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [isExpiringSoon, setIsExpiringSoon] = useState(false);
  const [showExpired, setShowExpired] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [editValues, setEditValues] = useState(null);
  const [expiryDashboard, setExpiryDashboard] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [selectedRange, setSelectedRange] = useState("thisMonth");

  const GetExpiryData = async (
    text,
    limit = currentLimit,
    offset = currentOffset,
  ) => {
    setloading(true);
    const payload = {
      company_id,
      start_date: "",
      end_date: "",
      search: searchByShortCode ? "" : text,
      short_code: searchByShortCode ? text : "",
      offset,
      limit,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      show_expired: showExpired,
      expired_within_7_days: isExpiringSoon,
    };
    try {
      const res1 = await getExpiryProducts(payload);
      if (res1?.result?.status_code === 200) {
        setExpiryData(res1?.result?.data || []);
      } else {
        setExpiryData([]);
      }
    } catch (error) {
      console.error("Error fetching expiry data:", error);
    } finally {
      setloading(false);
    }
  };

  const getExpiryDashboard = async () => {
    setOpenEditModal(false);
    try {
      let payload = {
        company_id: company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_EXPIRY_DASHBOARD,
        payload,
      );
      if (response?.data?.result?.status_code === 200) {
        setExpiryDashboard(response?.data?.result?.data);
      }
    } catch (error) {
      console.error("Error fetching expiry data:", error);
    } finally {
      setloading(false);
    }
  };

  // 🔹 Call only once when startDate / endDate / pagination change
  useEffect(() => {
    GetExpiryData("", currentLimit, currentOffset);
    getExpiryDashboard();
  }, [
    startDate,
    endDate,
    currentLimit,
    currentOffset,
    showExpired,
    isExpiringSoon,
  ]);

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_PRODUCT_EXPIRY_EXCEL,
      payload,
    );
    if (response?.data?.result?.status_code === 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_data);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (!base64Data || typeof base64Data !== "string") {
        alert("No valid file data available for download");
        return;
      }
      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss");
      const filename = `${t("expiry_products")}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const handleDeleteProduct = async (id, isDelete) => {
    Modal.confirm({
      title: t("Are you sure you want to remove this product?"),
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
      // content: t("This action cannot be undone."),
      okText: t("Yes"),
      cancelText: t("No"),
      okButtonProps: {
        className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
      },
      onOk: async () => {
        let payload = {
          record_id: id,
          is_delete: isDelete ? true : false,
          company_id: company_id,
        };
        try {
          const response = await axiosInstance.post(
            URLS.UPDATE_PRODUCT_EXPIRY,
            payload,
          );
          if (response?.data?.result?.status_code === 200) {
            toast.success(t("Product Deleted Successfully"));
            GetExpiryData("", 10, 0);
          } else {
            toast.error(t(response?.data?.result?.status));
          }
        } catch (error) {
          console.error("Error fetching expiry data:", error);
        } finally {
          setloading(false);
        }
      },
    });
  };

  const handleChange = (key, value) => {
    setEditValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleProductUpdate = async () => {
    setOpenEditModal(false);
    try {
      let payload = {
        record_id: editValues?.id,
        is_delete: false,
        company_id: company_id,
        lot_number: editValues?.batchNumber,
        quantity: editValues?.qty,
        expiry_date: editValues?.expiryDate,
        manufacturing_date: editValues?.manufactureDate,
        shelf_life_days: editValues?.shelfLife,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_EXPIRY,
        payload,
      );
      if (response?.data?.result?.status_code === 200) {
        toast.success(t("Product Expiry Updated Successfully"));
        GetExpiryData("", 10, 0);
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error fetching expiry data:", error);
    } finally {
      setloading(false);
    }
  };

  const cards = [
    {
      title: t("Expired Items"),
      count: `${expiryDashboard?.expired_item ? expiryDashboard?.expired_item : 0} ${t("Products")}`,
      icon: <XCircle size={22} />,
      bg: "bg-[#EFD7D0]",
      iconColor: "text-[#F25463]",
    },
    {
      title: t("Expiring within 7 days"),
      count: `${expiryDashboard?.expired_within_7_days ? expiryDashboard?.expired_within_7_days : 0} ${t("Products")}`,
      icon: <Clock size={22} />,
      bg: "bg-yellow-100",
      iconColor: "text-yellow-500",
    },
    // {
    //   title: "Low Stock Alerts",
    //   count: "12 Products",
    //   icon: <TrendingDown size={22} />,
    //   bg: "bg-blue-100",
    //   iconColor: "text-blue-500",
    // },
  ];

  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto pb-2 md:h-full bg-">
        <Navbar heading="Product Expiry" />
        <div className="custom-scrollbar flex-grow overflow-y-auto overflow-hidden md:ms-3">
          <div className="font-extrabold"></div>

          <div className="mt-4 px-2 sm:mt-6 sm:px-4 md:mt-8">
            <div className="mb-5 grid grid-cols-1 gap-3 rounded-lg sm:grid-cols-2 sm:gap-4 md:mb-7">
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between rounded-xl border border-[#DFEAF2] bg-[#F6F7F9] p-4 sm:p-6"
                >
                  <div>
                    <p className="text-sm text-[#718EBF]">{card.title}</p>
                    <p className="text-lg font-semibold text-gray-800 sm:text-xl">
                      {card.count}
                    </p>
                  </div>

                  <div
                    className={`w-12 h-12 flex items-center justify-center rounded-3xl ${card.bg} ${card.iconColor}`}
                  >
                    {card.icon}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div className="flex gap-2 flex-row sm:items-center md:gap-x-2">
                <div className="w-2/3 md:w-full">
                  <SearchBox
                    value={query}
                    // showBarcode={true}
                    searchResult={(values) => {
                      setquery(values);
                      GetExpiryData(values, 10, 0);
                      //  setloading(true);
                      // debouncedSearch(values)
                    }}
                    placeholder={t("search_product")}
                  />
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setSearchByShortCode(!searchByShortCode);
                  }}
                  className={`h-[40px] w-full rounded-md border px-2 text-sm whitespace-nowrap sm:w-auto ${
                    searchByShortCode
                      ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                      : "bg-white border-gray-300 text-gray-700"
                  }`}
                >
                  {t("Search Code")}
                </button>
              </div>

              <div className="flex gap-2 flex-row sm:items-center sm:gap-3">
                <div className="flex items-center gap-x-2">
                  <label className="flex cursor-pointer select-none items-center">
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={isExpiringSoon}
                        onChange={() => {
                          setShowExpired(false);
                          setIsExpiringSoon(!isExpiringSoon);
                        }}
                        className="sr-only"
                      />
                      <div
                        className={`box block h-6 w-12 rounded-full ${
                          isExpiringSoon ? "bg-green-500" : "bg-gray-500"
                        }`}
                      ></div>
                      <div
                        className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
                          isExpiringSoon ? "translate-x-full" : ""
                        }`}
                      ></div>
                    </div>
                  </label>
                  <p className="text-xs md:text-sm font-medium">
                    {t("Expiring Soon")}
                  </p>
                </div>

                <div className="flex items-center gap-x-2">
                  <label className="flex cursor-pointer select-none items-center">
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={showExpired}
                        onChange={() => {
                          setIsExpiringSoon(false);
                          setShowExpired(!showExpired);
                        }}
                        className="sr-only"
                      />
                      <div
                        className={`box block h-6 w-12 rounded-full ${
                          showExpired ? "bg-green-500" : "bg-gray-500"
                        }`}
                      ></div>
                      <div
                        className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
                          showExpired ? "translate-x-full" : ""
                        }`}
                      ></div>
                    </div>
                  </label>
                  <p className="text-xs md:text-sm font-medium">
                    {t("Show Expired")}
                  </p>
                </div>
                <button
                  className="flex h-10 w-[16%] md:w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white"
                  onClick={() => {
                    if (allStores) {
                      // Open the modal immediately if allStores is true
                      setExportModalOpen(true);
                    } else {
                      // Check permission for the specific path and open the modal if permission is granted
                      if (
                        checkPermission("/inventory/ProductExpiry", isGinne)
                      ) {
                        setExportModalOpen(true);
                      } else {
                        // Optionally handle permission denial (log or alert)
                        console.log(
                          "Permission denied for /inventory/ProductExpiry",
                        );
                      }
                    }
                  }}
                >
                  <DownloadOutlined style={{ fontSize: "1.5em" }} />
                  <span className="hidden md:block">
                    {t("Download in Excel")}
                  </span>
                </button>
              </div>
            </div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <ProductExpiryTable
                additionalData={expiryData}
                pagination={(values) => {
                  setCurrentLimit(values.limit);
                  setCurrentOffset(values.offset);
                  // GetExpiryData(values.limit, values.offset);
                }}
                onDelete={(id) => handleDeleteProduct(id, true)}
                onEditLine={(line) => {
                  let data = {
                    id: line?.id,
                    qty: line?.quantity,
                    batchNumber: line?.lot_number,
                    manufactureDate: line?.manufacturing_date
                      ? dayjs(line?.manufacturing_date)
                      : null,
                    shelfLife: line?.shelf_life_days,
                    expiryDate: line?.expiry_date
                      ? dayjs(line?.expiry_date)
                      : null,
                  };
                  setEditValues(data);
                  setOpenEditModal(true);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <Modal
        title={t("Expiry")}
        visible={openEditModal}
        onCancel={() => {
          setEditValues(null);
          setOpenEditModal(false);
        }}
        footer={null}
        width={
          typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 850
        }
      >
        <div className="expiry-page">
          <div className="mb-2 flex flex-wrap gap-2">
            <Input
              type="number"
              placeholder={t("Qty")}
              value={editValues?.qty}
              onChange={(e) => handleChange("qty", e.target.value)}
              onWheel={(e) => e.target.blur()}
              min={0}
              style={{ width: "90px", maxWidth: "100%" }}
              disabled={true}
            />
            <Input
              placeholder={t("Batch Number")}
              value={editValues?.batchNumber}
              onChange={(e) => handleChange("batchNumber", e.target.value)}
              style={{ width: "140px", maxWidth: "100%" }}
              disabled={!editValues?.qty}
            />

            <DatePicker
              placeholder={t("Manufacture Date")}
              value={editValues?.manufactureDate}
              onChange={(date) => handleChange("manufactureDate", date)}
              style={{ width: "190px", maxWidth: "100%" }}
              disabled={!editValues?.qty || editValues?.expiryDate}
            />

            <Input
              type="number"
              placeholder={t("Shelf Life (Days)")}
              value={editValues?.shelfLife}
              onChange={(e) => handleChange("shelfLife", e.target.value)}
              min={0}
              style={{ width: "140px", maxWidth: "100%" }}
              disabled={
                !editValues?.manufactureDate ||
                !editValues?.qty ||
                editValues?.expiryDate
              }
            />

            <DatePicker
              placeholder={t("Expiry Date")}
              value={editValues?.expiryDate}
              onChange={(date) => {
                handleChange("shelfLife", "");
                handleChange("expiryDate", date);
              }}
              style={{ width: "190px", maxWidth: "100%" }}
              disabled={!editValues?.qty || editValues?.manufactureDate}
            />
          </div>

          <div className="flex justify-end font-semibold mt-4">
            <Button
              onClick={handleProductUpdate}
              className="bg-primaryBlue hover:bg-primaryBlue"
              type="primary"
              // disabled={isButtonDisabled}
            >
              {t("save")}
            </Button>
          </div>
        </div>
      </Modal>
      {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Product Expiry Data")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
          showFutureDates={true}
        />
      )}
      {bulkUploadModal && (
        <BulkUploadExpiry
          isOpen={bulkUploadModal}
          onClose={() => setBulkUploadModal(false)}
        />
      )}
    </>
  );
};

export default ProductExpiry;
